// extracted by mini-css-extract-plugin
module.exports = {"airTempGraph":"AirTempGraph_airTempGraph__8H902"};